// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackAddressCreatedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/account/trackAddressCreated";

const useTrackAddressCreated = (
    parameters: TrackAddressCreatedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addressCreated, parameters, options);
};

export default useTrackAddressCreated;
